import React from 'react'
import useClearQueryCache from '../../features/declaration/form/api/useClearQueryCache'
import useDeclarationSessionKey from '../../features/declaration/form/components/useDeclarationSessionKey'
import useAuthGuard from '../../app/guards/useAuthGuard'
import EnsEditor from '../../features/declaration/form/ens/components/EnsEditor'
import { DeclarationEditorContextProvider } from '../../features/declaration/form/contexts/DeclarationEditorContext'
import { NctsErrorProvider } from '../../features/declaration/form/contexts/NctsErrorContext'
import { ConfirmProvider } from '../../shared/components/confirm/ConfirmProvider'
import { CalculatorModalProvider } from '../../features/declaration/form/components/calculator/CalculatorModalContext'

export function EnsEditorSession() {
  useClearQueryCache()

  return (
    <ConfirmProvider>
      <DeclarationEditorContextProvider isEns>
        <NctsErrorProvider>
          <CalculatorModalProvider>
            <EnsEditor />
          </CalculatorModalProvider>
        </NctsErrorProvider>
      </DeclarationEditorContextProvider>
    </ConfirmProvider>
  )
}

function EnsEditorPage() {
  useAuthGuard()
  const sessionKey = useDeclarationSessionKey()

  return <EnsEditorSession key={sessionKey} />
}

export default EnsEditorPage
